import React, { useEffect, useState } from "react";
import SimpleModal from "components/Modal/SimpleModal";
import { Button, Col, Form, Input, Row, Select, Spin } from "antd";
import IntlMessages from "util/IntlMessages";
import { useSelector, useDispatch } from "react-redux";
import {
  DataGetAction,
  DataGetActionAPI,
  DataRequestActionAPI,
} from "../../../../redux/actions/http";

const AssignWatchModal = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [careRecipients, setCareRecipients] = useState([]);
  const [corporateAccounts, setCorporateAccounts] = useState([]);

  const fetchTableData = () => {
    dispatch(
      DataGetAction(
        "getCorporateAccounts",
        { query: "all" },
        "gettingCorporateAccounts"
      )
    );
  };
  useEffect(() => {
    fetchTableData();
  }, []);

  const fetchCareRecipientData = (corporateUserId) => {
    form.setFieldsValue({
      careRecipient: null,
    });
    dispatch(
      DataGetAction(
        "getCareRecipient",
        {
          corporateUserId,
          query: "search",
          key: "imei",
        },
        "gettingCareRecipient"
      )
    );
  };

  const inventoryProps = useSelector((state) => state.inventory);
  const {
    inventorySpinner,
    inventorySuccess,
    inventoryError,
    assignWatchModalVisible,
    initialValues,
  } = inventoryProps;

  const usersProps = useSelector((state) => state.users);
  const { usersList, allCareRecipient } = usersProps;

  useEffect(() => {
    setCorporateAccounts([]);
    setCareRecipients([]);
    if (usersList.length > 0) {
      usersList.map((user) => {
        setCorporateAccounts((prev) => [
          ...prev,
          {
            label: user.fullName,
            value: user._id,
          },
        ]);
      });
    }
  }, [usersList]);

  useEffect(() => {
    setCareRecipients([]);
    if (allCareRecipient.length > 0) {
      allCareRecipient.map((careRecipient) => {
        setCareRecipients((prev) => [
          ...prev,
          { label: careRecipient.fullName, value: careRecipient._id },
        ]);
      });
    }
  }, [allCareRecipient]);

  const toggleAssignWatchModal = () => {
    dispatch({ type: "Hide_AssignWatch_Modal" });
    form.resetFields();
  };

  const assignWatch = (values) => {
    let data = {
      healthBandId: initialValues._id,
      corporateAccountId: values.coporateAccount,
      careRecipientId: values.careRecipient,
    };
    console.log(data);

    dispatch(
      DataRequestActionAPI(
        "PUT",
        "assignHealthBand",
        "EditInventory",
        data,
        "",
        "InventoryLoading",
        true
      )
    );
  };

  useEffect(() => {
    if (inventorySuccess) {
      toggleAssignWatchModal();
    }
  }, [inventorySuccess]);

  useEffect(() => {
    if (inventoryError) {
      toggleAssignWatchModal();
    }
  }, [inventoryError]);

  return (
    <>
      <SimpleModal
        visible={assignWatchModalVisible}
        width={500}
        modalFor="Hide_AssignWatch_Modal"
        title="Assign Watch"
      >
        <Form
          form={form}
          layout="vertical"
          name="assignWatch"
          onFinish={assignWatch}
        >
          <Row className="gx-d-flex gx-flex-row">
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-pl-0">
              <Form.Item
                name="coporateAccount"
                label="Coporate Accounts"
                rules={[
                  {
                    required: true,
                    message: "Coporate Account is required",
                  },
                ]}
              >
                <Select
                  options={corporateAccounts}
                  placeholder="Select Coporate Account"
                  onChange={(value) => fetchCareRecipientData(value)} // Add onChange handler to fetch care recipients
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="careRecipient"
                label="Care Recipient"
                rules={[
                  {
                    required: true,
                    message: "Care Recipient is required",
                  },
                ]}
              >
                <Select
                  options={careRecipients}
                  placeholder="Select Care Recipient"
                  disabled={careRecipients.length === 0}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">
                <Form.Item className="gx-mb-0">
                  <Button
                    type="default"
                    className="gx-pt-0 gx-mb-0 gx-mr-2"
                    htmlType="button"
                    onClick={() => toggleAssignWatchModal()}
                  >
                    <IntlMessages id="inventory.cancel" />
                  </Button>
                </Form.Item>
                <Form.Item className="gx-mb-0">
                  {inventorySpinner ? (
                    <Spin>
                      <Button
                        type="primary"
                        className="gx-pt-0 gx-mb-0"
                        disbaled
                        htmlType="button"
                      >
                        <IntlMessages id="inventory.save" />
                      </Button>
                    </Spin>
                  ) : (
                    <Button
                      type="primary"
                      className="gx-pt-0 gx-mb-0"
                      htmlType="submit"
                    >
                      <IntlMessages id="inventory.save" />
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Form>
      </SimpleModal>
    </>
  );
};

export default AssignWatchModal;
